<template>
  <div class="w-full">
    <form class="bg-white shadow-md rounded  pt-6 pb-8 mb-4">
      <div class="mb-4">
        <label class="block text-gray-700 text-sm font-bold mb-2" for="username">
          Tytuł posta
        </label>
        <input
          class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          id="username"
          type="text"
          placeholder="Title"
        />
      </div>
      <div class="mb-6">
        <label class="block text-gray-700 text-sm font-bold mb-2" for="password">
          Content
        </label>
        <textarea
          class="shadow appearance-none border border-red-500 rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline"
          id="content"
          type="content"
          rows="20"
        />
      </div>
      <div class="flex items-center justify-between">
        <button
          class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
          type="button"
        >
          Zapisz
        </button>
        <a
          class="inline-block align-baseline font-bold text-sm text-blue-500 hover:text-blue-800"
          href="#"
          @click="cancel()"
        >
          Anuluj
        </a>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: "PostForm",
  data() {
    return {
      isEditing: false,
    };
  },
  methods: {
    cancel() {
      console.log("object", this.isEditing);
      this.isEditing = false;
    },
  },
};
</script>

<style lang="scss" scoped></style>
